module.exports = __webpack_public_path__ + "static/media/account.89853aa5.svg";